// Shared loading / error / empty states for every /app screen (BRIEFS C10.1).
// Simple words for a grade-4 reader; the Try again button is the 46 px primary button.
import React from 'react';
import { C, FONT, button } from './theme';

export const LOAD_ERROR_TEXT = 'Could not load. Check the internet and press Try again.';

export function Loading({ text = 'Loading…', style }) {
  return (
    <div role="status" data-testid="v2-loading" style={{ color: C.muted, fontSize: 15, fontFamily: FONT.ui, ...style }}>
      {text}
    </div>
  );
}

export function LoadError({ onRetry, text = LOAD_ERROR_TEXT, style }) {
  return (
    <div role="alert" data-testid="v2-load-error" style={{
      display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 12,
      fontFamily: FONT.ui, ...style,
    }}>
      <div style={{ color: C.bad, fontSize: 15 }}>{text}</div>
      {onRetry && (
        <button type="button" data-testid="v2-try-again" style={button.primary} onClick={() => onRetry()}>
          Try again
        </button>
      )}
    </div>
  );
}

export function Empty({ text, children, style }) {
  return (
    <div data-testid="v2-empty" style={{ color: C.muted, fontSize: 15, fontFamily: FONT.ui, ...style }}>
      {text}{children}
    </div>
  );
}
